export default {
    "personalHint": "Choose your optional emails across all channels. Changes save automatically.",
    "adminHint": "Choose which emails this member may receive from this channel. Their personal opt-outs still apply.",
    "loading": "Loading email preferences…",
    "loadError": "We couldn’t load email preferences. Please try again.",
    "retry": "Try again",
    "optional": "Optional emails",
    "personalOff": "This member has turned this off in their personal preferences.",
    "saveError": "Your change wasn’t saved. Please try again.",
    "saving": "Saving…",
    "saved": "Email preferences saved.",
    "syncPending": "Saved in Studio. Updating our email service; we’ll retry automatically if needed.",
    "required": "Always-on emails",
    "requiredHint": "These emails are necessary for account access and services you use. They cannot be turned off here.",
    "deliveryHint": "These choices apply to future emails. An email already being delivered may still arrive. Existing unsubscribe choices continue to apply. In-app and push notifications are unchanged.",
    "channelNotifications": {
        "heading": "Channel notifications",
        "intro": "Choose email and bell alerts separately for each channel. Your overall email choices still apply. Bell choices also control browser push for new cards.",
        "transports": { "email": "Email", "in_app": "Studio bell and browser push" },
        "completedEdits": "Completed edits for assigned channel admins and CSRs",
        "team": "Team activity",
        "mine": "My content only",
        "off": "Off",
        "categories": {
            "new_posts": "New posts",
            "coaching": "Coaching posts",
            "content_updates": "Content updates",
            "comments_likes": "Comments, mentions and likes",
            "tasks": "Task assignments",
            "media_requests": "Content requests",
            "collaboration": "Collaboration invitations",
            "reviews": "Review requests and reminders",
            "approved_content": "Content approvals",
            "declined_content": "Requested changes",
            "reports": "Reports and sharing"
        }
    },
    "manageTeam": "Manage team email preferences",
    "teamHint": "Admins can manage members in their channels. MarketScale super admins can manage all channels.",
    "findChannel": "Find a channel",
    "search": "Search",
    "channel": "Channel",
    "chooseChannel": "Choose a channel",
    "member": "Member",
    "chooseMember": "Choose a member",
    "findMember": "Find a member by name or full email",
    "noMembers": "No members match this search in this channel.",
    "previous": "Previous",
    "next": "Next",
    "categories": {
        "domain_updates": {
            "label": "Domain updates",
            "description": "Changes to the email domains associated with your channel."
        },
        "ai_visibility": {
            "label": "AI Visibility",
            "description": "Recommendations and reports about how your company appears in AI answers."
        },
        "trending_topics": {
            "label": "Trending Topics",
            "description": "Current news and suggested conversations relevant to your company."
        },
        "coaching": {
            "label": "Coaching alerts",
            "description": "New coaching posts, replies and acknowledgements."
        },
        "new_posts": {
            "label": "New posts",
            "description": "New posts in your channel."
        },
        "comments_likes": {
            "label": "Comments, mentions and likes",
            "description": "Activity and mentions on content you follow."
        },
        "content_updates": {
            "label": "Content updates",
            "description": "New versions, completed edits and downloadable content."
        },
        "reviews": {
            "label": "Review requests",
            "description": "Requests to review content and reminders for pending approvals."
        },
        "approved_content": {
            "label": "Content approvals",
            "description": "Updates when your content is approved."
        },
        "declined_content": {
            "label": "Requested changes",
            "description": "Updates when content is declined or needs changes."
        },
        "gallery": {
            "label": "Gallery updates",
            "description": "New items in your channel gallery."
        },
        "media_requests": {
            "label": "Content requests",
            "description": "Requests to contribute content and reminders to respond."
        },
        "collaboration": {
            "label": "Collaboration",
            "description": "Invitations to collaborate on content, folders and projects."
        },
        "channel_updates": {
            "label": "Channel activity",
            "description": "New members and changes in your channel."
        },
        "reminders": {
            "label": "Reminders and getting started",
            "description": "Activity reminders, onboarding tips and optional follow-ups."
        },
        "reports": {
            "label": "Reports and feedback",
            "description": "Editing reports, ratings, surveys and social sharing summaries."
        },
        "tasks": {
            "label": "Tasks and support updates",
            "description": "Task assignments, comments and progress on support requests."
        },
        "account_security": {
            "label": "Account and security",
            "description": "Sign-in, password resets, email verification, account access and security changes."
        },
        "booking_confirmations": {
            "label": "Booking confirmations and changes",
            "description": "Confirmations, cancellations and essential changes to bookings you made."
        },
        "billing_service": {
            "label": "Billing and essential service notices",
            "description": "Receipts, payments, data-retention notices and important service changes."
        },
        "requested_deliveries": {
            "label": "Requested deliveries",
            "description": "Links and confirmations needed to complete a download or another action you requested."
        }
    }
}
